import { Component, OnInit, Output, EventEmitter} from '@angular/core';
import { Router} from '@angular/router';
import { IMyDpOptions, IMyDateModel } from 'mydatepicker';
import { OrderdateService } from '../../services/orderdate.service';

@Component({
  selector: 'app-calendar-filter',
  templateUrl: './calendar-filter.component.html',
  styleUrls: ['./calendar-filter.component.scss']
})
export class CalendarFilterComponent implements OnInit {
  date: string;
  startDate = '';
  endDate = '';
  setFromDate = true;
  dateNotice = 'Select start date';
  quickview: boolean;
  setdateRange: any = {
    startDate: '',
    endDate: ''
  };
  public myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'yyyy-mm-dd',
    inline: true,
    width: '100%',
    disableWeekends: true
  };
    selected: boolean;
  constructor(private router: Router, private order_date: OrderdateService) {
    this.quickview = true;
  }

  ngOnInit() {}
  onDateChanged(date: IMyDateModel) {
    // event properties are: event.date, event.jsdate, event.formatted and event.epoc
   if (!this.quickview) {
    if (this.setFromDate) {
      this.dateNotice = 'Select end date';
      this.startDate = date.formatted;
      this.setFromDate = false;
    } else {
      this.dateNotice = 'Select start date';
      this.endDate = date.formatted;
      this.setFromDate = true;
    }
   } else {
     this.startDate = date.formatted;
     this.endDate = '';
     this.passDateRageData();
   }
  }
  passDateRageData() {
    this.setdateRange = {
      startDate: this.startDate,
      endDate: this.endDate
    }
    this.order_date.changeOrderDate(this.setdateRange);
    // this.router.navigate(['/home/manage/user/order', this.setdateRange]);
    this.router.navigate(['/home/manage/user/order']);
  }
  calendaroption(e): void {
    if(e.target.value === '0') {
      this.quickview = true;
    } else {
      this.quickview = false;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/calendar-filter/calendar-filter.component.ts